<template>
  <div class="animated fadeIn col-md-12">
    <searchCard
      :filterCatch="false"
      :hasFilter="false"
      :title="$lang.InterviewPlaningShowTime"
      :url="url"
      :html="false"
      :showTotalRowsCount="false"
      :allowFields="$lang.search_parvandeh_fildes"
      ref="interviewPlaningShowTime"
      @updatePermissions="updatePermissions"
      @getOther="updateOtherData"
      @getItems="updateItemsData"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="py-1 mb-3 border-bottom d-md-flex d-block align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <span
              class="mr-1 fs_1_3rem w_h_35 border bg-light rounded-circle d-flex align-items-center justify-content-center"
            >
              <i
                v-if="item.is_active"
                class="fas fa-hourglass-half text-primary"
              />
              <i v-else class="far fa-hourglass text-danger" />
            </span>
            <b class="px-1 fs_1rem" v-html="generateParvandehTitle(item)" />
          </div>
        </b-col>
        <b-col cols="12" md="12">
          <b-row>
            <b-col cols="12" md="12" class="mb-3">
              <b-alert show variant="danger" v-if="!item.is_active">
                <i class="fas fa-times-circle fa-lg mr-1" />
                <span
                  v-text="
                    'بعلت سپری شدن تاریخ مصاحبه ، اطلاعات مصاحبه منقضی شده است'
                  "
                />
              </b-alert>
            </b-col>
            <b-col cols="12" md="12" class="py-2">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.interviewLang.interview_date_time" />:
              <span
                class="text-muted"
                v-html="
                  `<b class='text-info'>${pathOr(
                    '',
                    ['interview_date', 'jalali'],
                    item
                  )}</b> در <b class='text-info'>${pathOr(
                    '',
                    ['place_caption'],
                    item
                  )}</b>`
                "
              />
            </b-col>
            <b-col cols="12" md="12" class="py-2">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.interviewTime" />:
              {{ pathOr("", ["interview_time"], item) }}
            </b-col>
            <b-col cols="12" md="2" class="py-2">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.interviewLang.room_number" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['room_number'], item)"
              />
            </b-col>
            <b-col
              cols="12"
              md="3"
              class="py-2"
              v-if="pathOr('', ['interview_person_kind', 'id'], item) === 1"
            >
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.interviewLang.interview_person_kind" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['interview_person_kind', 'caption'], item)"
              />
            </b-col>
            <b-col
              cols="12"
              md=""
              class="py-2"
              v-if="pathOr(null, ['virtual_interview_url'], item)"
            >
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.virtual_interview_url" />:
              <a
                :href="pathOr('#', ['virtual_interview_url'], item)"
                target="_blank"
                class="font-weight-bold"
                v-text="pathOr('', ['virtual_interview_url'], item)"
              />
            </b-col>
            <b-col cols="12" md="12" class="py-2">
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.interviewLang.place_address" />:
              <span
                class="text-muted"
                v-html="nl2br(pathOr('', ['place_address'], item))"
              />
            </b-col>
            <b-col
              cols="12"
              md="12"
              class="py-2"
              v-if="pathOr('', ['interview_person_kind', 'id'], item) !== 1"
            >
              <i class="far fa-check-circle mr-1" />
              <b v-text="$lang.interviewLang.description" />:
              <span
                class="text-muted"
                v-html="pathOr('', ['place_description'], item)"
              />
            </b-col>
            <b-col
              cols="12"
              md="12"
              class="py-2 border-top"
              v-if="examPacks.length"
            >
              <i class="far fa-check-circle mr-1" />
              <b v-text="'لطفا در نظرسنجی زیر شرکت کنید:'" />:
              <b-row class="mt-1">
                <b-col
                  cols="12"
                  md="auto"
                  v-for="(item, index) in examPacks"
                  :key="index"
                >
                  <a
                    v-b-tooltip.hover
                    title="جهت مشاهده پرسشنامه کلیلک کنید"
                    :href="item.address"
                    class="btn btn-info text-white mr-2 my-1 w-100"
                    target="_blank"
                  >
                    {{ pathOr("", ["exam_pack", "name"], item) }}
                  </a>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </searchCard>
  </div>
</template>

<script>
import searchCard from "@/components/base/searchCard";
import { pathOr, includes } from "ramda";
import { isAdmin, nl2br } from "@/shared/utils";

export default {
  components: {
    searchCard,
  },
  inject: ["interviewAzmoonExecutePersonRepository"],
  data() {
    return {
      hiddenFields: [
        "created_at.jalali",
        "created_by",
        "updated_by",
        "updated_at",
      ],
      url: this.$config.api_url + this.$config.interview.interview_planing_show,
      permissions: [],
      otherData: null,
      items: [],
      examPacks: [],
    };
  },
  watch: {
    otherData(value) {
      value && this.getResearchAzmoonExecutePerson();
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    nl2br,
    generateParvandehTitle() {
      const fullName = pathOr("", ["person", "full_name"], this.otherData);
      const nationalCode = pathOr(
        "",
        ["person", "national_code"],
        this.otherData
      );
      return `${fullName} (${nationalCode})`;
    },
    updatePermissions(data) {
      this.permissions = [...data];
    },
    updateOtherData(data) {
      this.otherData = data;
    },
    updateItemsData(data) {
      this.items = data;
    },
    async getResearchAzmoonExecutePerson() {
      const azmoonId = pathOr(
        null,
        ["0", "survey_azmoon_execute_id"],
        this.items
      );
      const parvandehCode = pathOr(null, ["parvandeh", "code"], this.otherData);
      const personCode = pathOr(null, ["person", "code"], this.otherData);
      if (!azmoonId || !parvandehCode || !personCode) return;
      try {
        const response = await this.interviewAzmoonExecutePersonRepository.list(
          azmoonId,
          parvandehCode,
          parvandehCode,
          personCode
        );
        this.examPacks = pathOr([], ["data", "data"], response);
      } catch (err) {
        this.$generateError(err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.fs_1_3rem {
  font-size: 20px;
}

.w_h_35 {
  width: 35px;
  height: 35px;
}
</style>
